import {useRef} from 'react';
import {useNavigate} from 'react-router-dom';
import {Modal} from '@cvent/carina/components/Modal';
import {Button} from '@cvent/carina/components/Button';

type BillingLoadErrorModalProps = {
  handleClose: () => void;
};

const BillingLoadErrorModal = ({handleClose}: BillingLoadErrorModalProps) => {
  const navigate = useNavigate();
  const headerRef = useRef<HTMLHeadingElement | null>(null);

  const handleGoBack = () => {
    handleClose();
    navigate(-1);
  };

  return (
    <Modal
      isOpen
      format="sm"
      testID="billing-load-error-modal"
      aria-labelledby="billing-load-error-title"
    >
      <div className="flex flex-col box-border w-[420px] p-6">
        <h1
          id="billing-load-error-title"
          ref={headerRef}
          tabIndex={-1}
          className="text-[24px] font-bold leading-[var(--carina-line-height-tight)] text-[var(--carina-text-color-base)] mb-4"
        >
          Something went wrong
        </h1>
        <p className="text-[14px] leading-[var(--carina-line-height-normal)] text-[var(--carina-text-color-base)] mb-6">
          There was a problem loading your billing information. Try again later.
          For assistance, contact support at{' '}
          <a
            aria-label="socialtables support email link"
            href="mailto:ST.support@cvent.com"
            className="text-[var(--carina-link-color,#006ae1)] no-underline"
          >
            ST.support@cvent.com
          </a>
          .
        </p>
        <div className="flex justify-center">
          <Button
            text="Go back"
            onClick={handleGoBack}
            type="button"
            appearance="filled"
            className="w-[164px]"
          />
        </div>
      </div>
    </Modal>
  );
};

export default BillingLoadErrorModal;
